import {
  useCfaFlag,
  useCnicFlag,
  useDhsFlag,
  useEpaFlag,
  useEquinorFlag,
  useGovernmentOfOntarioFlag,
  useJapanDemoFlag,
  useTennesseeNationalGuardFlag,
} from './featureFlags';

export const EPA_DEMO_ORG_NAME = 'jimmy.king@disastertech.com Demo Group';
export const EPA_DISPLAY_ORG_NAME = 'Environmental Protection Agency';
export const DHS_DISPLAY_ORG_NAME = 'Department of Homeland Security';
export const CNIC_DISPLAY_ORG_NAME = 'Commander, Navy Installations Command';
export const ONTARIO_DISPLAY_ORG_NAME = 'Government of Ontario';
export const EQUINOR_DISPLAY_ORG_NAME = 'Equinor';
export const JAPAN_DISPLAY_ORG_NAME = 'US Forces Japan';
export const CFA_DISPLAY_ORG_NAME = 'Chick-fil-A';
export const TNG_DISPLAY_ORG_NAME = 'Tennessee National Guard';

export type DemoOrgDisplayFlags = {
  ontarioEnabled?: boolean;
  equinorEnabled?: boolean;
  japanEnabled?: boolean;
  cnicEnabled?: boolean;
  dhsEnabled?: boolean;
  epaEnabled?: boolean;
  cfaEnabled?: boolean;
  tngEnabled?: boolean;
};

export function displayGroupName(
  name: string | undefined,
  flags: DemoOrgDisplayFlags
): string {
  if (!name) return '';
  if (name !== EPA_DEMO_ORG_NAME) return name;
  if (flags.ontarioEnabled) return ONTARIO_DISPLAY_ORG_NAME;
  if (flags.equinorEnabled) return EQUINOR_DISPLAY_ORG_NAME;
  if (flags.japanEnabled) return JAPAN_DISPLAY_ORG_NAME;
  if (flags.cnicEnabled) return CNIC_DISPLAY_ORG_NAME;
  if (flags.dhsEnabled) return DHS_DISPLAY_ORG_NAME;
  if (flags.epaEnabled) return EPA_DISPLAY_ORG_NAME;
  if (flags.cfaEnabled) return CFA_DISPLAY_ORG_NAME;
  if (flags.tngEnabled) return TNG_DISPLAY_ORG_NAME;
  return name;
}

export function useDisplayGroupName(name: string | undefined): string {
  return displayGroupName(name, {
    ontarioEnabled: useGovernmentOfOntarioFlag(),
    equinorEnabled: useEquinorFlag(),
    japanEnabled: useJapanDemoFlag(),
    cnicEnabled: useCnicFlag(),
    dhsEnabled: useDhsFlag(),
    epaEnabled: useEpaFlag(),
    cfaEnabled: useCfaFlag(),
    tngEnabled: useTennesseeNationalGuardFlag(),
  });
}
